import {stringifyDate} from './dates';

function buildFormData(formData: FormData, data: Record<any, any>, parentKey?: string): void;
function buildFormData(formData: FormData, data: any, parentKey?: string): void {
    if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
        const keys = Object.keys(data);
        keys.forEach(key => {
            buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
        });

        if (!keys.length && parentKey) {
            formData.append(parentKey, '');
        }

        return;
    }

    if (!parentKey) {
        return;
    }

    let value = data;
    if ([null, undefined].includes(data)) {
        value = '';
    } else if (typeof data === 'boolean') {
        value = +data;
    } else if (data instanceof Date) {
        value = stringifyDate(data);
    }

    formData.append(parentKey, value);
}

export function convertObjectToFormData(data: Record<any, any>): FormData {
    const formData = new FormData();

    buildFormData(formData, data);

    return formData;
}
